const sponsors = [
    // {
    //     id: 1,
    //     title: "vishandelanemoontje",
    //     logo: "'tAnemoontje.jpg",
    //     rank: 2,
    //     url: "http://www.vishandelanemoontje.be/"
    // },
    {
        id: 2,
        title: "Al_kopie",
        logo: "alKopie.png",
        rank: 4,
        url: "https://www.alkopie.com/"
    },
    {
        id: 3,
        title: "autocenter Mertens",
        logo: "autocenterMertens.jpg",
        rank: 4,
        url: "http://www.autocentermertens.be/nlbe/start.aspx"
    },
    // {
    //     id: 4,
    //     title: "B_K Getinte Ruiten",
    //     logo: "B&KGetinteRuiten.png",
    //     rank: 3,
    //     url: "https://www.bkgetinteruiten.be/"
    // },
    {
        id: 5,
        title: "Bakkerij TImmermans",
        logo: "bakkerijTimmermans.png",
        rank: 4,
        url: "https://bakkersonline.be/be-nl/timmermans/category/9352"
    },
    {
        id: 6,
        title: "Bart Laeremans",
        logo: "bartLaeremans.png",
        rank: 2,
        url: "https://nl.wikipedia.org/wiki/Bart_Laeremans_(politicus)"
    },
    {
        id: 7,
        title: "Bike Center Mertens",
        logo: "bikeCenterMertens.png",
        rank: 3,
        url: "https://www.bikecentermertens.be/"
    },
    // {
    //     id: 8,
    //     title: "Ben Van Sande",
    //     logo: "benVanSande.png",
    //     rank: 2,
    //     url: "https://www.benvansande.be/"
    // },
    // {
    //     id: 9,
    //     title: "Cafe Galoiske",
    //     logo: "cafeGaloiske.png",
    //     rank: 3,
    //     url: "https://zekaa.com/galoiske-t"
    // },
    {
        id: 10,
        title: "Cafe in de Veldkant",
        logo: "cafeInDeVeldkant.png",
        rank: 4,
        url: null
    },
    {
        id: 11,
        title: "Immo DEWAELE",
        logo: "immoDeWaele.png",
        rank: 3,
        url: "https://www.dewaele.com/nl/cbi-immo-is-nu-dewaele"
    },
    {
        id: 12,
        title: "Chris Selleslagh",
        logo: "chrisSelleslagh.png",
        rank: 3,
        url: "https://nl.wikipedia.org/wiki/Chris_Selleslagh"
    },
    {
        id: 13,
        title: "Colora",
        logo: "colora.png",
        rank: 2,
        url: "https://www.colora.be/nl/"
    },
    {
        id: 14,
        title: "Cornelissen",
        logo: "cornelissen.png",
        rank: 3,
        url: "https://www.beenhouwerijcornelissen.be/"
    },
    {
        id: 15,
        title: "Crelan",
        logo: "crelan.png",
        rank: 3,
        url: "https://www.crelan.be/nl/particulieren"
    },
    {
        id: 16,
        title: "De Herberg van Grimbergen",
        logo: "deHerbergVanGrimbergen.png",
        rank: 4,
        url: "https://herbergvangrimbergen.be/"
    },
    {
        id: 17,
        title: "De Kantine van het Bos",
        logo: "deKantineVanHetBos.png",
        rank: 4,
        url: "http://www.wazzaah.be/kantine/"
    },
    {
        id: 18,
        title: "Dranken Van Campenhout",
        logo: "drankenVanCampenhout.png",
        rank: 3,
        url: "https://grimbergsehandelaars.be/drankencentrale-van-campenhout/"
    },
    // {
    //     id: 19,
    //     title: "Enigma",
    //     logo: "enigma.png",
    //     rank: 3,
    //     url: "https://enigma.be/"
    // },
    {
        id: 20,
        title: "EVN Pharma",
        logo: "EVNPharma.png",
        rank: 3,
        url: "https://www.apotheekborgt.be/"
    },
    {
        id: 21,
        title: "Fleur Louise",
        logo: "fleurLouise.png",
        rank: 3,
        url: "https://fleurlouise.com/index.php/16-2/"
    },
    // {
    //     id: 22,
    //     title: "Forrier",
    //     logo: "forrier.png",
    //     rank: 3,
    //     url: "https://forrier.sereni.be/nl/"
    // },
    {
        id:23,
        title: "Fort verzekeringen",
        logo: "fortVerzekeringen.png",
        rank: 3,
        url: "https://fort.be/nl/home/"
    },
    {
        id: 24,
        title: "Frituur _t Pleintje Borgt",
        logo: "frituur'tPleintjeBorgt.jpg",
        rank: 2,
        url: "https://www.tpleintjeborgt.be/"
    },
    {
        id: 25,
        title: "Gammatex",
        logo: "gammatec.png",
        rank: 3,
        url: "https://www.gammatec.be/nl/home/"
    },
    {
        id: 26,
        title: "Hygge vakantiewoning",
        logo: "hyggeVakantiewoning.png",
        rank: 4,
        url: "https://www.hygge-vakantiewoning.be/"
    },
    // {
    //     id: 27,
    //     title: "JoVelo",
    //     logo: "joVelo.png",
    //     rank: 4,
    //     url: "https://www.fietsreparateur.be/"
    // },
    {
        id: 28,
        title: "Kapsalon Ann",
        logo: "kapsalonAnn.png",
        rank: 4,
        url: "https://www.openingsurengids.be/kapsalon-ann/grimbergen/1"
    },
    {
        id: 29,
        title: "Karakter Invest",
        logo: "karakterInvest.png",
        rank: 4,
        url: "http://www.karakterinvest.be/"
    },
    {
        id: 30,
        title: "Keurslager VanDamme",
        logo: "vanDammeKeurslager.jpg",
        rank: 4,
        url: "https://keurslagervandamme.be/"
    },
    {
        id: 31,
        title: "ROLLVOLET",
        logo: "rollvolet.jpg",
        rank: 3,
        url: "https://www.rollvolet.be/"
    },
    {
        id: 32,
        title: "Lombaerts-Van Laer",
        logo: "lombaertsVanLaer.png",
        rank: 4,
        url: "http://www.lombaerts-vanlaer.be/"
    },

    {
        id: 33,
        title: "MGMS",
        logo: "MGMS.png",
        rank: 2,
        url: null
    },
    {
        id: 34,
        title: "Music Company",
        logo: "musicCompany.png",
        rank: 2,
        url: "https://www.music-company.be/"
    },
    {
        id: 35,
        title: "Optiek De Temmerman",
        logo: "optiekDeTemmerman.png",
        rank: 3,
        url: "https://optiek-detemmerman.be/"
    },
    {
        id: 36,
        title: "Orchis",
        logo: "orchis.png",
        rank: 4,
        url: "https://www.orchisraes.be/"
    },
    // {
    //     id: 37,
    //     title: "Read All",
    //     logo: "readAll.png",
    //     rank: 4,
    //     url: "https://www.openingsuren.vlaanderen/read-all/1800-vilvoorde/grimbergsesteenweg-90"
    // },
    {
        id: 38,
        title: "Spira",
        logo: "spira.png",
        rank: 2,
        url: "https://www.spira.be/"
    },
    {
        id: 39,
        title: "Toyota De Bruyn",
        logo: "toyotaDeBruyn.png",
        rank: 3,
        url: "https://www.toyotadebruyn.be/about/vilvoorde"
    },
    {
        id: 40,
        title: "Veranda Thomas",
        logo: "verandaThomas.jpg",
        rank: 2,
        url: "https://verandathomas.be/"
    },
    {
        id: 41,
        title: "Vince Verspecht",
        logo: "vinceVerspecht.png",
        rank: 3,
        url: "https://www.vincebvba.be/"
    },
    {
        id: 42,
        title: "Wim Rondas - Fintro",
        logo: "wimRondasFintro.png",
        rank: 3,
        url: "https://www.fintro.be/fr/public/particuliers"
    },
    // {
    //     id: 43,
    //     title: "EVE dakwerken",
    //     logo: "EVEDakwerken.jpg",
    //     rank: 2,
    //     url: null
    // },
    {
        id: 44,
        title: "Leen De Cock",
        logo: "leenDeCock.jpg",
        rank: 4,
        url: "https://www.leendecock.be/"
    },
    {
        id: 45,
        title: "Seduti",
        logo: "seduti.png",
        rank: 2,
        url: "https://www.seduti.be/"
    },
    {
        id: 46,
        title: "Studio Dermaux",
        logo: "studioDermaux.png",
        rank: 4,
        url: null
    },
    {
        id: 47,
        title: "'t Tuintje",
        logo: "tuintje.png",
        rank: 2,
        url: "https://www.ttuintje.be/"
    },
    {
        id: 48,
        title: "Carrefour Market Grimbergen",
        logo: "carrefourMarketGrimbergen.png",
        rank: 2,
        url: "https://winkels.carrefour.be/nl/s/carrefour/carrefour-market-grimbergen/204"
    },
    {
        id: 49,
        title: "Planten en potterie Van Doorslaer",
        logo: "PlantenEnPotterieVanDoorslaer.png",
        rank: 3,
        url: "https://www.plantenvandoorslaer.be/"
    },
    {
        id: 50,
        title: "Kapsalon Sven",
        logo: "kapsalonSven.png",
        rank: 3,
        url: "https://kapsalonsven.be/"
    },
    {
        id: 51,
        title: "Keuken Dovy Grimbergen",
        logo: "keukenDovyGrimbergen.png",
        rank: 2,
        url: "https://www.dovykeukens.be/toonzalen/keukens-vlaams-brabant/keukens-grimbergen/"
    }
];

export default sponsors